import React from 'react';

import styles from './Divider.module.scss';
import * as types from './Divider.type';

export function Divider({ color = '#E5E7EB' }: types.Divider) {
  return <div className={styles.wrapper} style={{ backgroundColor: color }} />;
}
